import React from 'react';
import styles from './ActFastMessage.module.css';

const ActFastMessage = () => (
  <div className={styles.container}>
    <p>Act fast! Items in your cart are not on hold.</p>
  </div>
);

export default ActFastMessage;
